import React, { useState } from "react";
import { images } from "../../assets/images";
import InputWithIcon from "../../components/FormFields/InputWithIcon/index";
import { icons } from "../../assets/icons";
import Checkbox from "../../components/FormFields/Checkbox";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { toast } from "react-toastify";

const Login = () => {

  const navigate = useNavigate();
  const { login, user } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const onClickLogin = async () => {
    if (!username || !password) {
      toast.error("Please enter username and password");
      return;
    }
    await login(username, password);
  };

  if (user?.access_token) {
    return <Navigate to="/" />;
  }

  return (
    <div
      className="login-container"
      style={{
        background: `url(${images.loginBackground}) no-repeat center center/cover`,
      }}
    >
      <div className="login-form-container">
        <img
          src={images.mainLogo}
          className="main-logo"
          alt="keventer's logo"
        />
        <div className="login-form flex flex-col justify-center">
          <div className="font-size-large mb-6">
            Please login to your account
          </div>
          <InputWithIcon
            leftIcon={icons.userIcon}
            placeholder="Enter your username"
            containerClassName="mb-4"
            wrapperClassName="w-[100%]"
            onChange={(text) => setUsername(text)}
          />
          <InputWithIcon
            leftIcon={icons.passwordIcon}
            placeholder="Password"
            wrapperClassName="w-[100%]"
            onChange={(text) => setPassword(text)}
          />
          <div className="remember-forgot-container flex justify-end mt-6 w-[100%]">
            {/* <Checkbox title="Remember Me" /> */}
            <div className="font-size-small text-[var(--appColor)] cursor-pointer" onClick={()=>navigate("/forgetPassword")}>
              Forget Password?
            </div>
          </div>
          <button
            className="login-button font-family-bold font-size-large !h-[5.8rem]"
            onClick={onClickLogin}
            type="button"
          >
            Login
          </button>
          <div className="font-size-small text-[var(--ultraLightGray)] mt-10 m-auto">
            &copy; Powered by CorePeelers
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
